import React, { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../../firebase';
import { Scissors, Menu, X, Download } from 'lucide-react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [installPrompt, setInstallPrompt] = useState(null);
    const [siteSettings, setSiteSettings] = useState({
        showGallery: true,
        logoUrl: '',
        siteName: 'GOLDEN BLADE',
        logoSize: 40,
        logoAlt: '' // Descrição do logo para SEO
    });

    useEffect(() => {
        const handler = (e) => {
            e.preventDefault();
            setInstallPrompt(e);
        };
        window.addEventListener('beforeinstallprompt', handler);

        const docRef = doc(db, "siteContent", "main");
        const unsubscribe = onSnapshot(docRef, (doc) => {
            if (doc.exists()) {
                const data = doc.data();
                setSiteSettings(prev => ({ ...prev, ...data }));
            }
        });

        return () => {
            window.removeEventListener('beforeinstallprompt', handler);
            unsubscribe();
        };
    }, []);

    const handleInstallClick = () => {
        if (!installPrompt) {
            return;
        }
        installPrompt.prompt();
    };

    const baseNavLinks = [
        { href: "#sobre", label: "Sobre Nós" },
        { href: "#servicos", label: "Serviços" },
        { href: "#depoimentos", label: "Depoimentos" },
        { href: "#contato", label: "Contato" },
    ];
    
    const navLinks = siteSettings.showGallery
        ? [
            ...baseNavLinks.slice(0, 2),
            { href: "#galeria", label: "Galeria" },
            ...baseNavLinks.slice(2)
          ]
        : baseNavLinks;

    return (
        <>
            <header className="bg-background/80 backdrop-blur-lg sticky top-0 z-50">
                <div className="container mx-auto px-6 flex justify-between items-center">
                    <a href="#home" className="flex items-center space-x-3 text-2xl font-bold text-primary hover:opacity-80 transition-opacity duration-300">
                        {siteSettings.logoUrl ? (
                            <img 
                                src={siteSettings.logoUrl} 
                                alt={siteSettings.logoAlt || siteSettings.siteName} // Usa a descrição de SEO, com fallback para o nome do site
                                style={{ height: `${siteSettings.logoSize || 40}px` }}
                            />
                        ) : (
                            <>
                                <Scissors size={28} />
                                <span>{siteSettings.siteName}</span>
                            </>
                        )}
                    </a>
                    <nav className="hidden md:flex items-center space-x-8">
                        {navLinks.map((link) => (
                            <a key={link.href} href={link.href} className="text-text/80 hover:text-primary transition-colors duration-300 font-medium">{link.label}</a>
                        ))}

                    </nav>
                    <div className="md:hidden">
                        <button onClick={() => setIsMenuOpen(true)} className="text-primary focus:outline-none">
                            <Menu size={28} />
                        </button>
                    </div>
                </div>
            </header>

            <div className={`md:hidden fixed inset-0 bg-neutral-900 z-50 flex flex-col items-center justify-center transition-opacity duration-300 ease-in-out ${isMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
                <button onClick={() => setIsMenuOpen(false)} className="absolute top-6 right-6 text-primary focus:outline-none">
                    <X size={32} />
                </button>
                <nav className="flex flex-col items-center space-y-8">
                    {navLinks.map((link) => (
                        <a 
                            key={link.href} 
                            href={link.href} 
                            onClick={() => setIsMenuOpen(false)} 
                            className="text-text text-2xl hover:text-primary transition-colors duration-300"
                        >
                            {link.label}
                        </a>
                    ))}
                </nav>
            </div>
        </>
    );
};

export default Header;
